import { FC } from 'react'
import { Draggable, Droppable } from 'react-beautiful-dnd'
import { FILTER_TYPE_OPTIONS } from '@mobileConstants'
import { Box, Paper, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ChecklistIcon from '@mui/icons-material/Checklist'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import DateRangeIcon from '@mui/icons-material/DateRange'
import CheckBoxIcon from '@mui/icons-material/CheckBox'

const iconMap: Record<string, React.ReactNode> = {
  search: <SearchIcon />,
  'arrow-drop-down': <ArrowDropDownIcon />,
  checklist: <ChecklistIcon />,
  'toggle-on': <ToggleOnIcon />,
  'calendar-today': <CalendarTodayIcon />,
  'date-range': <DateRangeIcon />,
  'check-box': <CheckBoxIcon />,
}

export const AvailableFiltersPanel: FC = () => {
  return (
    <Box>
      <Typography variant='h6' gutterBottom>
        Available Filters
      </Typography>
      <Droppable droppableId='AVAILABLE_FILTERS' isDropDisabled>
        {provided => (
          <Box ref={provided.innerRef} {...provided.droppableProps}>
            {FILTER_TYPE_OPTIONS.map((option, index) => (
              <Draggable key={option.value} draggableId={`NEW:${option.value}`} index={index}>
                {(provided, snapshot) => (
                  <Paper
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    sx={{
                      p: 2,
                      mb: 1,
                      cursor: 'grab',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      opacity: snapshot.isDragging ? 0.5 : 1,
                      '&:hover': {
                        bgcolor: 'action.hover',
                      },
                    }}
                  >
                    {iconMap[option.icon]}
                    <Typography>{option.label}</Typography>
                  </Paper>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </Box>
        )}
      </Droppable>
    </Box>
  )
}





